import { useInfiniteQuery } from '@tanstack/react-query';
import { getInstagramMedia } from '@/services/instagram.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useInstagramMediaInfinite = (params: { limit?: number; enabled?: boolean } = {}) => {
    const limit = params.limit ?? 25;
    return useInfiniteQuery({
        queryKey: queryKeys.instagram.media(limit),
        queryFn: ({ pageParam }) => getInstagramMedia({ limit, after: pageParam }),
        initialPageParam: null as string | null,
        getNextPageParam: (lastPage) => lastPage.paging.nextCursor,
        enabled: params.enabled ?? true,
    });
};
